/* @flow */
import {edapTriggerPriceSummaryDisplay} from '@homeaway/react-price-summary';
import {trigger as edapTrigger} from './edapWrapper';
import type {ListingShape as MapHitListingShape} from '../components/MapHit/MapHit';
import type {ListingShape as HitListingShape} from '../components/Hit/Hit';

import type {Badge} from '../components/HitInfo/HitInfo';

export const LIST_HIT_CLICK = 'search.hit.click';
export const MAP_HIT_CLICK = 'search.map.hit.click';
export const MAP_MARKER_CLICK = 'search.map.property.click';
export const SEARCH_RESULT_SET_SELECTED = 'search_result_set.selected';

type HitEdapEventAction =
    | typeof LIST_HIT_CLICK
    | typeof MAP_HIT_CLICK
    | typeof MAP_MARKER_CLICK
    | typeof SEARCH_RESULT_SET_SELECTED;

type ListingShape = HitListingShape | MapHitListingShape;

export type HitEventDataListingShape = {
    listing: ListingShape,
    hitIndex?: number,
    page?: number,
    pageSize?: number
};

export type MultiUnitPropertyDropDownShape = {
    propertyId: number
};

export type MultiUnitPropertyResultCountShape = {
    propertyId: number,
    resultCount: number
};

function parseBadges(partnerBadges: ?(Badge[])) {
    let badges;
    if (partnerBadges) {
        badges = partnerBadges.map(({id}) => id);
    }

    return (badges || []).join(',');
}

export const triggerHitEdapEvent = (
    eventData: HitEventDataListingShape,
    eventCategory: HitEdapEventAction,
    delayProcessing?: boolean,
    skipReportPositioning?: boolean,
    skipPriceSummaryTrigger?: boolean,
    isHighFrequency?: boolean
) => {
    const options = {delayProcessing};
    const {
        listingId,
        partnerBadges,
        priceSummary,
        virtualTourBadge
    } = eventData.listing;
    const badges = [
        parseBadges(partnerBadges),
        virtualTourBadge && 'virtualTourBadge'
    ]
        .filter(Boolean)
        .join(',');

    let data = {
        eventlistingids: listingId,
        badges
    };

    if (!skipReportPositioning && eventData.hitIndex !== null) {
        const relativePosition = eventData.hitIndex + 1;
        let absolutePosition;
        if (eventData.page && eventData.pageSize) {
            absolutePosition =
                (eventData.page - 1) * eventData.pageSize +
                eventData.hitIndex +
                1;
        } else {
            absolutePosition = relativePosition;
        }

        data = {
            ...data,
            absoluteposition: absolutePosition.toString(),
            relativeposition: relativePosition.toString()
        };
    }
    if (isHighFrequency) {
        data = {
            ...data,
            highfrequency: 'true'
        };
    }

    edapTrigger(eventCategory, data, options);

    if (priceSummary && !skipPriceSummaryTrigger) {
        edapTriggerPriceSummaryDisplay(priceSummary, {delayProcessing});
    }
};

const triggerSearchResultSetSelectedEdapEvent = (
    eventData: string,
    eventCategory: HitEdapEventAction,
    delayProcessing?: boolean
) => {
    const options = {delayProcessing};

    let data = {
        action_location: eventData
    };

    edapTrigger(eventCategory, data, options);
};

export const triggerListHitClickEDAPEvent = (
    eventData: HitEventDataListingShape
) => {
    triggerHitEdapEvent(eventData, LIST_HIT_CLICK, true, false, false);
    triggerSearchResultSetSelectedEdapEvent(
        'search',
        SEARCH_RESULT_SET_SELECTED,
        false
    );
};

export const triggerMapHitClickEDAPEvent = (
    eventData: HitEventDataListingShape
) => {
    triggerHitEdapEvent(eventData, MAP_HIT_CLICK, true, false, false);
};

export const triggerMarkerClickEDAPEvent = (
    eventData: HitEventDataListingShape
) => {
    triggerHitEdapEvent(eventData, MAP_MARKER_CLICK, false, false, true);
};

export const triggerExpandedGroupHitClickEDAPEvent = (
    eventData: HitEventDataListingShape
) => {
    triggerHitEdapEvent(eventData, LIST_HIT_CLICK, true, true, false);
};
